import BonusCollection from "../../model/bonus/BonusCollection";
import Page from "../framework/Page";
import ParentView from "../framework/ParentView";
import { PageIds } from "../PageIds";
import ActiveBonusView from "./ActiveBonusView";

export default class ActiveBonusesView extends ParentView {
    /**
     * @param {string} parentId
     * @param {BonusCollection} bonusCollection 
     */
    constructor(parentId, bonusCollection) {
        super(parentId, PageIds.ACTIVE_BONUSES_PANEL);

        const elementId = this.getElementId();

        const bonuses = bonusCollection.activeBonuses;
        for (let i = 0; i < bonuses.length; i++) {
            const bonusView = new ActiveBonusView(elementId, elementId + '_' + i, bonuses[i]);
            this.addView(bonusView);
        }

        /**
         * @constant
         * @type {BonusCollection}
         */
        this.bonusCollection = bonusCollection;

        // /**
        //  * @type {number}
        //  */
        // this.displayedCount = this.bonusCollection.activeBonuses.length;
        /**
         * @type {number}
         */
        this.displayedChangeCount = -1;
    }

    /**
     * @override
     */
    initializeView() {
        // <div id="activeSkillsPanel" class="active-skills-panel">      
        // </div>

        const parentElement = Page.getElement(this.parentId);
        Page.createElement('div', parentElement, this.getElementId(), 'active-skills-panel');

        super.initializeView();
    }

    /**
     * @override
     */
    updateViewContents() {

        if (this.displayedChangeCount !== this.bonusCollection.activeChangeCount) {
            this.displayedChangeCount = this.bonusCollection.activeChangeCount;

            console.log('-------------------------------');
            console.log('active change count: ' + this.bonusCollection.activeChangeCount);
            console.log('   active bonuses:  ' + this.bonusCollection.activeBonuses.length);

            // Clear out our children and start over.
            //this.clearChildViews();
            this.removeChildViewElements();

            const elementId = this.getElementId();

            const bonuses = this.bonusCollection.activeBonuses;
            for (let i = 0; i < bonuses.length; i++) {
                const skillView = new ActiveBonusView(elementId, elementId + '_' + i, bonuses[i]);
                this.addView(skillView);

                console.log('  adding view: ' + bonuses[i].id);
    
                // Initialize the newly created view
                skillView.initializeView();
            }
        }

        super.updateViewContents();
    }

    /**
     * Returns the value that the display property should be set to in order to make
     * the element visible. 
     * 
     * By default this is 'block', but you should overwrite this if the element is 'display:flex' or something other than 'display:block'.
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'flex';
    }
}